export default __webpack_public_path__ + "static/jsconf-55f0de5c4168e8b31ceb8e0c02808a12.png";